<template>
  <div class="__container">
    <form class="__form" @submit.prevent="onSearch">
      <div class="d-flex align-items-center gap-3">
        <BaseText :value="filters.licenseCode" @input="filters.licenseCode = $event" title="شماره مجوز " placeholder="شماره مجوز" labelClass="labelClass" class="__input" />

        <DateTimeOffset
          class="labelStyle __input"
          range
          :value="filters.dateRange"
          @input="filters.dateRange = $event"
          title="تاریخ "
          placeholder="از تاریخ تا تاریخ"
          :hasDefaultDate="false"
        />

        <BaseText :value="filters.title" @input="filters.title = $event" title="عنوان دوره " placeholder="عنوان دوره" labelClass="labelClass" class="__input" />

        <ComboBox :searchedData="faculties" title="تامین کننده" placeholder="تامین کننده" @select="fillSelectedFaculty" :selectedValue="selectedFaculty" class="__input" />
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <b-button variant="secondary" @click=";(filters = { title: '', dateRange: [], licenseCode: '', facultyId: '' }), (selectedFaculty = '')">پاک کردن</b-button>

        <Button type="submit" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </form>
  </div>
</template>

<script>
import Button from '../../common/Button.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import moocReportingProvider from '../../../services/mooc/reporting'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
export default {
  name: 'Reporting',
  components: { BaseText, DateTimeOffset, Button, ComboBox },
  data: () => {
    return {
      filters: {
        title: '',
        dateRange: [],
        licenseCode: '',
        facultyId: null,
      },
      faculties: [],
      selectedFaculty: '',
    }
  },
  methods: {
    fillSelectedFaculty(e) {
      if (!e) {
        this.filters.facultyId = null
        return false
      }
      this.filters.facultyId = this.faculties.find((item) => item.value === e).key
      this.selectedFaculty = this.faculties.find((item) => item.value === e).value
    },

    onSearch() {
      if (this.filters.dateRange.length) {
        this.filters.dateRange[0] = this.filters.dateRange[0] ? new Date(this.filters.dateRange[0]).toISOString() : undefined
        this.filters.dateRange[1] = this.filters.dateRange[1] ? new Date(this.filters.dateRange[1]).toISOString() : undefined
      }
      this.$emit('onSearch', this.filters)
    },

    async getReportTableInput() {
      try {
        const req = await moocReportingProvider.getReportTableInput()
        if (req.status === 200)
          req.data.data.output.forEach((item) => {
            this.faculties.push({ value: item.title, key: item.id })
          })
      } catch (error) {
        console.log(error)
      }
    },
  },
  async mounted() {
    await this.getReportTableInput()
  },
}
</script>

<style lang="scss" scoped>
.__container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 10px 20px rgba(18, 38, 63, 0.0313726);
  padding: 30px 20px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.__form {
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 30px 20px;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

.__input {
  width: 45rem;
}
</style>
